import { css } from 'styled-components';
import brand from './brand';
export default css `
  &::-webkit-scrollbar-track {
    background-color: ${brand.secondary.grey.light};
  }

  &::-webkit-scrollbar {
    background-color: ${brand.secondary.grey.light};
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${brand.primary.purple.base};
    border: 1px solid ${brand.secondary.grey.light};
    border-radius: 2px;
    cursor: pointer;
  }
`;
